import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SensorDataUploadComponent } from './sensor-data-upload/sensor-data-upload.component';
import { BiologicalDataUploadComponent } from './biological-data-upload/biological-data-upload.component'
import { PhysicochemicalDataComponent } from './physicochemical-data/physicochemical-data.component';
import { LiteratureDataUploadComponent } from './literature-data-upload/literature-data-upload.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataUploadRoutingModule } from './data-upload-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker'; 
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DataUploadRoutingModule,
    MatRadioModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    SweetAlert2Module.forRoot()
  ],
  exports: [SensorDataUploadComponent, BiologicalDataUploadComponent, LiteratureDataUploadComponent, PhysicochemicalDataComponent],
  declarations: [SensorDataUploadComponent, BiologicalDataUploadComponent, LiteratureDataUploadComponent, PhysicochemicalDataComponent],
  providers: [],
})
export class DataUploadModule {}
